module.exports = __webpack_public_path__ + "593a3d53/img/comments-icon.fdec7fdb.svg";